import React, { useState, useEffect, useReducer } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import getUrl from "../function/getUrl.js";
import getDay from "../function/getDay.js";
import checkLogin from "../function/checkLogin.js";

// 1. 初始狀態改為扁平物件
const initialState = {};

const day_list = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

// 2. Reducer 邏輯優化
function reducer(state, action) {
  switch (action.type) {
    case 'FETCH_SUCCESS':
      // 直接將整理後的資料物件作為 state
      return { ...action.payload };

    case 'change_classDate':
      const dateWeek = new Date(action.payload).getDay();
      return {
        ...state,
        classDate: action.payload,
        week: day_list[dateWeek]
      };

    case 'update_field':
      // 通用更新邏輯，減少重複的 case
      return {
        ...state,
        [action.field]: action.payload
      };

    default:
      return state;
  }
}

const ClassEdit = () => {
  checkLogin();
  const param = useParams();
  const classDBID = param.classDBID;
  const url = getUrl();
  const token = sessionStorage.getItem("token");

  // 使用 Reducer
  const [state, dispatch] = useReducer(reducer, initialState);
  
  // 保持外部清單的 useState
  const [staffList, setStaffList] = useState([]);
  const [classProcessList, setClassProcessList] = useState([]);

  useEffect(() => {
    // 取得課程資料並初始化 Reducer
    fetch(`${url}/appGet/getClassData?classDBID=${classDBID}&token=${token}`)
      .then(res => res.json())
      .then(data => {
        // 資料整理

        delete data.createDate;
        delete data.updateDate;
        delete data.operator
        console.log(data)
        data.operator=sessionStorage.getItem("staffDBID")
        console.log(data)
        const dateWeek = new Date(data.classDate).getDay();
        data.week = day_list[dateWeek];

        dispatch({ type: 'FETCH_SUCCESS', payload: data });
      });

    // 取得教練清單
    fetch(`${url}/appGet/getStaffData?token=${token}`)
      .then(res => res.json())
      .then(data => setStaffList(data));

    // 課程主題清單
    fetch(`${url}/appGet/getClassProcessList?token=${token}`)
      .then(res => res.json())
      .then(json => setClassProcessList(json));
  }, [classDBID, url, token]);

  function handelSummit() {
    console.log("saving state ",state)
    const operator = sessionStorage.getItem("staffDBID")
    console.log(operator)
    
    const formData = new FormData();
  // 1. 自動迭代 state 中的所有 key-value
    // 這會處理 age, limit, classTime, coachID, assistantID, classDate, classProcess, available, webApp, trial, photography
    Object.entries(state).forEach(([key, value]) => {
      // 過濾掉不需要傳回後端的計算欄位（例如 week）
      if (key !== "week") {
        // 使用 ?? "" 確保不會傳出 "undefined" 或 "null" 字串
        formData.append(key, value ?? "");
      }
    });

    // 2. 額外手動添加 state 之外的必要資訊
    // formData.append("operator", operator);
    formData.append("token", token)

    // console.log(formData)

    // fetch(`${url}/appPost/updateClass`, {
    //   method: "POST",
    //   body: formData,
    //   mode: "cors",
    // })
    //   .then((res) => {
    //     return res.json()

    //   })

    fetch(`${url}/appPost/updateClass`, {
      method: "POST",
      body: formData,
      mode: "cors",
    })
    .then(res => res.json())
    .then(() => {
      window.location.href = `/SingleClassView/${classDBID}`;
    });
  }

  return (
    <>
      <div className="container vw-100" style={{ maxWidth: "500px" }}>
        <div className="card bg-info text-white p-2">
          <h5 className="m-1">課程編號:{classDBID} - {state.classDate ?? ""} 資料維護</h5>
        </div>

        <div className="mt-2">
          <div className="card mt-2">
            <div className="card-header alert-info">課程基本資料區</div>
            <div className="card-body">
              {/* 開課日期 */}
              <div className="m-1">
                <div className="input-group">
                  <div className="input-group-prepend">
                    <span className="input-group-text alert-info">開課日期</span>
                  </div>
                  <input
                    type="date"
                    className="form-control"
                    value={state.classDate ?? ""}
                    onChange={(e) => dispatch({ type: "change_classDate", payload: e.target.value })}
                    required
                  />
                  <div className="input-group-prepend">
                    <span className="input-group-text alert-info">星期：{state.week ?? ""}</span>
                  </div>
                </div>
              </div>

              {/* 開課時間 */}
              <div className="m-1">
                <div className="input-group">
                  <div className="input-group-prepend">
                    <span className="input-group-text alert-info">開課時間</span>
                  </div>
                  <input
                    type="text"
                    className="form-control"
                    value={state.classTime ?? ""}
                    onChange={(e) => dispatch({ type: "update_field", field: "classTime", payload: e.target.value })}
                    required
                  />
                </div>
              </div>

              {/* 班別年紀 */}
              <div className="m-1">
                <div className="input-group">
                  <div className="input-group-prepend">
                    <span className="input-group-text alert-info">班別年紀</span>
                  </div>
                  <select 
                    className="custom-select" 
                    value={state.age ?? ""} 
                    onChange={(e) => dispatch({ type: "update_field", field: "age", payload: e.target.value })}
                  >
                    <option value="">請選擇...</option>
                    {["1-2Y", "2-3Y", "2M", "3-6M", "3-7Y", "6-12M", "ELP", "備用", "暑期班", "水中攝影", "自由練習", "體驗"].map(age => (
                      <option key={age} value={age}>{age}</option>
                    ))}
                  </select>
                </div>
              </div>

              {/* 人數上限 */}
              <div className="m-1">
                <div className="input-group">
                  <div className="input-group-prepend">
                    <span className="input-group-text alert-info">人數上限</span>
                  </div>
                  <input
                    type="text"
                    className="form-control"
                    value={state.limit ?? ""}
                    onChange={(e) => dispatch({ type: "update_field", field: "limit", payload: e.target.value })}
                  />
                </div>
              </div>

              {/* 選單類欄位：APP選課 / 是否開課 / 是否體驗 / 水中攝影 */}
              {[
                { label: "開放APP選課", field: "webApp" },
                { label: "是否開課", field: "available" },
                { label: "是否開放體驗", field: "trial" }
              ].map(item => (
                <div className="m-1" key={item.field}>
                  <div className="input-group">
                    <div className="input-group-prepend">
                      <span className="input-group-text alert-info">{item.label}</span>
                    </div>
                    <select 
                      className="custom-select" 
                      value={state[item.field] ?? "false"}
                      onChange={(e) => dispatch({ type: "update_field", field: item.field, payload: e.target.value })}
                    >
                      <option value="true">Yes</option>
                      <option value="false">No</option>
                    </select>
                  </div>
                </div>
              ))}

              <div className="m-1">
                <div className="input-group">
                  <div className="input-group-prepend">
                    <span className="input-group-text alert-info">是否為水中攝影</span>
                  </div>
                  <select 
                    className="custom-select" 
                    value={state.photography ?? "0"}
                    onChange={(e) => dispatch({ type: "update_field", field: "photography", payload: e.target.value })}
                  >
                    <option value="1">Yes</option>
                    <option value="0">No</option>
                  </select>
                </div>
              </div>
            </div>
          </div>

          <div className="card mt-2">
            <div className="card-header alert-primary">授課資料區</div>
            <div className="card-body">
              {/* 教練姓名 */}
              <div className="m-1">
                <div className="input-group">
                  <div className="input-group-prepend">
                    <span className="input-group-text alert-primary">教練姓名</span>
                  </div>
                  <select 
                    className="custom-select" 
                    value={state.coachID ?? ""} 
                    onChange={(e) => dispatch({ type: "update_field", field: "coachID", payload: e.target.value })}
                  >
                    <option value="">尚未指派</option>
                    {staffList.filter(s => s.coach === "true" && s.alive === "true").map(item => (
                      <option key={item.staffDBID} value={item.staffDBID}>{item.name}</option>
                    ))}
                  </select>
                </div>
              </div>

              {/* 助教 */}
              <div className="m-1">
                <div className="input-group">
                  <div className="input-group-prepend">
                    <span className="input-group-text alert-primary">助教</span>
                  </div>
                  <select 
                    className="custom-select" 
                    value={state.assistantID ?? ""} 
                    onChange={(e) => dispatch({ type: "update_field", field: "assistantID", payload: e.target.value })}
                  >
                    <option value="">不需助教</option>
                    {staffList.filter(s => s.coach === "true" && s.alive === "true" && s.staffDBID !== state.coachID).map(item => (
                      <option key={item.staffDBID} value={item.staffDBID}>{item.name}</option>
                    ))}
                  </select>
                </div>
              </div>

              {/* 課程主題 */}
              <div className="m-1">
                <div className="input-group">
                  <div className="input-group-prepend">
                    <span className="input-group-text alert-primary">課程主題</span>
                  </div>
                  <select
                    className="form-control"
                    value={state.classProcess ?? ""}
                    onChange={(e) => dispatch({ type: "update_field", field: "classProcess", payload: e.target.value })}
                  >
                    <option value="">請選擇</option>
                    {classProcessList.map((item, idx) => (
                      <option key={idx} value={item.classProcess}>{item.classProcess}</option>
                    ))}
                  </select>
                </div>
              </div>
            </div>
          </div>

          {/* 操作按鈕 */}
          <div className="card mt-2 p-1" style={{ width: "100%" }}>
            <button type="button" onClick={handelSummit} className="btn btn-danger">更新</button>
            <Link to={`/SingleClassView/${classDBID}`}>
              <div className="btn alert-dark mt-1" style={{ width: "100%" }}>取消</div>
            </Link>
          </div>
        </div>
      </div>
    </>
  );
};

export default ClassEdit;
